import { connect } from 'react-redux';
import { BUILDER } from '../../../../src/shared/abilities';
import { compose, pure } from '../../../../src/web/utils/react';
import { widget } from '../../../../src/web/components/widgets/decorators';
import { getPages } from '../../../../src/web/store/modules/pages';
import { getId } from '../../../../src/web/store/modules/page';
import { requestForMarinas } from '../../../../src/web/store/modules/contact';
import { getId as getPageBuilderId } from '../../../../src/web/store/modules/pageBuilder';
import { NAME, ID } from './properties';
import EmailContactForm from './EmailContactForm';
import editor from '../../../../src/web/components/widgets/decorators/editor';
import Editor from './Editor/Editor';

const component = compose(
  connect(
    state => ({
      pages: getPages(state),
      pageId: getId(state),
      pageBuilderId: getPageBuilderId(state),
      isRequesting: state.contact.requesting,
      requested: state.contact.requested,
      showSuccessMessage: state.contact.showSuccessMessage,
      errorMessage: state.contact.errorMessage,
      site: state.site,
    }),
    {
      handleRequest: requestForMarinas,
    },
  ),
  pure(),
  editor(Editor),
  widget(
    { name: NAME, category: 'Forms', componentId: ID },
  ),
)(EmailContactForm);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
